<ng-multiselect-dropdown #container class="custom_dropdown" [placeholder]="'custom placeholder'"
[settings]="dropdownSettings" [data]="dropdownList" [(ngModel)]="selectedItems"
(onSelect)="onItemSelect($event)" (onSelectAll)="onSelectAll($event)">
</ng-multiselect-dropdown>
